// extracted by mini-css-extract-plugin
export default {"buttonContainer":"footerButtons_buttonContainer__tQpJK","container":"footerButtons_container__yFFCJ"};